import { IonSpinner } from "@ionic/react";
import { hideModal } from "global/context/action/modal/modal";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../../global/context/Provider";
import {
  resetOrdenEstudio,
  wsDeleteOrdenEstudio,
} from "../../../../context/Actions/ordenEstudio/ordenEstudio";
import {
  limpiarListaMultimedia,
  wsGetListaMultimediaPaciente,
} from "../../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../../context/Provider";
import { MotivoRechazoBotones, MotivoRechazoContainer } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
const MotivoRechazo = ({
  motivoRechazo,
  motivoRechazoObservacion,
  motivoRechazoRecepcion,
  idturno,
}) => {
  const { turnosPacienteState, ordenEstudioDispatch, turnosPacienteDispatch } =
    useContext(PortalContext);

  const { modalDispatch } = useContext(GlobalContext);
  const { ubicacionState, pasoDispatch, puntoControlDispatch } =
    useContext(AutocheckContext);
  const [loadingButton, setLoadingButton] = useState(false);

  const subirDeNuevo = () => {
    if (
      Array.isArray(turnosPacienteState.turnosPaciente.listaMultimedia) &&
      !turnosPacienteState.turnosPaciente.loading &&
      turnosPacienteState.turnosPaciente.listaMultimedia.length > 0
    ) {
      turnosPacienteState.turnosPaciente.listaMultimedia.map((item, index) =>
        wsDeleteOrdenEstudio(idturno, item.idRemoto)(ordenEstudioDispatch)
      );
      limpiarListaMultimedia()(turnosPacienteDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
    } else {
      hideModal()(modalDispatch);
    }
  };

  useEffect(() => {
    let subirNuevamente = () => {
      setLoadingButton(false);
    };
    setLoadingButton(true);
    wsGetListaMultimediaPaciente(
      idturno,
      false,
      false,
      subirNuevamente
    )(turnosPacienteDispatch);
  }, []);

  const irPuntoControl = () => {
    const idTipoPuntoControl = 6;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
    hideModal()(modalDispatch);
  };

  return (
    <MotivoRechazoContainer>
      <span className="rb18l">{motivoRechazoObservacion}</span>
      <span className="rb18l">
        <span className="rb18m">Motivo de rechazo: </span>
        {motivoRechazo}
      </span>
      <span className="rb18l">
        {motivoRechazoRecepcion && (
          <span className="rb18m">
            Motivo de recepción: {motivoRechazoRecepcion}
          </span>
        )}
      </span>
      <MotivoRechazoBotones>
        <button className="btn-motivoRechazo rb18m" onClick={subirDeNuevo}>
          {loadingButton ? (
            <span>
              <IonSpinner name="lines" />
            </span>
          ) : (
            "Subir de nuevo"
          )}
        </button>
        {!!ubicacionState?.ubicacion?.data && (
          <button
            className="btn-solicitarAtencion rb18m"
            onClick={irPuntoControl}
          >
            Solicitar atención
          </button>
        )}
      </MotivoRechazoBotones>
    </MotivoRechazoContainer>
  );
};

export default MotivoRechazo;
